import * as React from 'react'
import { CoachHeader, CoachHeaderLight } from '../CoachHeader'
import { TranslationProvider } from '../../shared/TranslationProvider'
import translations from '../locales.json'
import { useTranslation } from '../../../hooks/useTranslation'
import parse from 'html-react-parser'
import CoachCard from './CoachCard'
import AccoladeCards, { LiaisonAccoladeCards } from './AccoladeCards'
import { CoachingArticle } from './CoachingArticle'
import YnsIcon from '~/components/icons/YnsIcon'

const Index = ({ locale, ...props }) => {
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope="javascript.components.coach_services.OutplacementBenefits.MeetYourCoach"
    >
      <MeetYourCoach {...props} />
    </TranslationProvider>
  )
}
export default Index

function MeetYourCoach({
  coach,
  coach_photo,
  transparent_coach_photo,
  coach_quote,
  coach_bio,
  accolades,
  select_premium_only,
  what_to_expect_one_to_one_coaching,
  liaison,
  liason_image_url,
}) {
  const { yearsExperience, numClientsSupported } = accolades

  const { t } = useTranslation()

  const quote = coach_quote || t('liaison_quote')

  const satisfactionRating = accolades.satisfactionRating

  return (
    <div className="m-4 flex flex-col gap-10 font-roboto xl:m-12">
      <div className="flex flex-col gap-6">
        <CoachHeader className="flex flex-col xl:block">
          <CoachHeaderLight>
            {liaison ? t('header.liaison_your') : t('header.meet_your')}
          </CoachHeaderLight>{' '}
          {liaison
            ? t('accolades.coach_liaison_team')
            : t('header.personal_career_coach')}
        </CoachHeader>

        <CoachCard
          coach={coach}
          coach_photo={coach_photo}
          transparent_coach_photo={transparent_coach_photo}
          accolades={accolades}
          liaison={liaison}
          liason_image_url={liason_image_url}
        />

        <div className="col-span-3 grid grid-cols-3 gap-6 xl:hidden">
          {liaison ? (
            <LiaisonAccoladeCards />
          ) : (
            <AccoladeCards
              yearsExperience={yearsExperience}
              numClientsSupported={numClientsSupported}
              satisfactionRating={satisfactionRating}
            />
          )}
        </div>

        <div className="grid grid-cols-11 font-roboto xl:gap-20">
          {liaison ? (
            <LiaisonDescription />
          ) : (
            <CoachBio t={t} coach={coach} coach_bio={coach_bio} />
          )}
          <div className="order-first col-span-12 flex max-h-[17rem] items-center justify-center rounded-[20px] bg-[#E0F2F9] bg-intoo-logo bg-right bg-no-repeat p-4 xl:order-last xl:col-span-5">
            <div className="font-roboto text-lg font-semibold italic text-intoo-blue-medium">
              &ldquo;{quote}&rdquo;
            </div>
          </div>
        </div>

        {select_premium_only && (
          <CoachingArticle article={what_to_expect_one_to_one_coaching} />
        )}
      </div>
    </div>
  )
}

const LiaisonDescription = () => {
  const { t } = useTranslation('understanding_the_process')

  const list = t('list', { returnObjects: true })

  return (
    <div className="col-span-11 mt-6 flex flex-col gap-4 xl:col-span-6 xl:mt-0">
      <div className="text-3.5xl font-bold text-intoo-green-coachcta">
        {t('title')}:
      </div>
      <div>{t('description')}</div>
      <div className="flex flex-col gap-4">
        {list.map((item, index) => (
          <div className="flex items-center gap-2" key={index}>
            <YnsIcon name={'coach-services-circle'} />
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}

const CoachBio = ({ t, coach, coach_bio }) => {
  return (
    <div className="col-span-11 mt-6 flex flex-col xl:col-span-6 xl:mt-0">
      <div className="text-3.5xl font-bold text-intoo-green-coachcta">
        {t('about.about_coach', { first_name: coach.first_name })}:
      </div>
      <p>{parse(coach_bio)}</p>
    </div>
  )
}
